import { systemInfoConstants } from "./systemInfo.constants";
const initialState = {
    Brand:'',
    SystemDescription: '',
    PhoneStr: '',
    Cellphone:'',
    Instagram: '',
    WhatsApp: '',
    TelegramChannel: '',
}

export function systemInfo(state = initialState, action) {
    switch (action.type) {
        case systemInfoConstants.GET_SYSTEM_SUCCESS:
            return {
                ...state,
                ...action.systemInfo
            }
        case systemInfoConstants.GET_SYSTEM_FAILURE:
            return state;

        case systemInfoConstants.ClearSystemInfo:
            return {};

        default:
            return state;
    }
}